import { render, staticRenderFns } from "./ImageFormatIcon.vue?vue&type=template&id=3de7a93c&scoped=true"
import script from "./ImageFormatIcon.vue?vue&type=script&lang=js"
export * from "./ImageFormatIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de7a93c",
  null
  
)

export default component.exports